import React from "react";
import { I18nextProvider } from "react-i18next";
import { RouteObject, useRoutes } from "react-router";

import i18n from "./i18n";
import { HomeLayout, PoppableLayout } from "./components";
import { BillPage, HomePage, PaymentPage } from "./pages";
import { PlateNumberHistoryProvider, OverlayProvider } from "./providers";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomeLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
    ],
  },
  {
    path: "/bill/:plateNumber",
    element: <PoppableLayout />,
    children: [
      {
        index: true,
        element: <BillPage />,
      },
    ],
  },
  {
    path: "/payment/:invoiceIds",
    element: <PoppableLayout />,
    children: [
      {
        index: true,
        element: <PaymentPage />,
      },
    ],
  },
];

const App: React.FC = () => {
  const routing = useRoutes(routes);

  return (
    <>
      <OverlayProvider>
        <PlateNumberHistoryProvider>
          <I18nextProvider i18n={i18n}>
            <React.Suspense fallback={"Loading ..."}>{routing}</React.Suspense>
          </I18nextProvider>
        </PlateNumberHistoryProvider>
      </OverlayProvider>
    </>
  );
};

export default App;
